export const formatDisplayName = (name) => {
  const nameWithNoSpecialCharacters = name.replace(RegExp('&', 'g'), 'and')
    .replace(RegExp('[-\\s]+', 'g'), '_')
    .replace(RegExp('\\W', 'g'), '')
    .replace(RegExp('_{2,}', 'g'), '_')
  const nameWithCapitalizedWords = nameWithNoSpecialCharacters.split('_').map((word) => word[0].toUpperCase() + word.slice(1))
  return nameWithCapitalizedWords.join('_')
}

export const formattedDate = () => {
  const today = new Date().toISOString()
  return today.split('T')[0].replace(/-/g, '_')
}
